import tw, { styled } from 'twin.macro'
export const FullWidthBackgroundContainer = styled.div<{
  backgroundColor?: string | null
}>(({ backgroundColor }) => [
  tw`bg-accentroGray-full z-index[-1] width[100vw] absolute left-1/2 right-1/2 margin-left[-50vw] margin-right[-50vw] h-full`,
  !!backgroundColor && `background-color: ${backgroundColor};`,
])
